var React = require('react');

function FacebookInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M23.625 12C23.625 17.8125 19.3594 22.6406 13.7812 23.4844V15.375H16.5L17.0156 12H13.7812V9.84375C13.7812 8.90625 14.25 8.01562 15.7031 8.01562H17.1562V5.15625C17.1562 5.15625 15.8438 4.92188 14.5312 4.92188C11.9062 4.92188 10.1719 6.5625 10.1719 9.46875V12H7.21875V15.375H10.1719V23.4844C4.59375 22.6406 0.375 17.8125 0.375 12C0.375 5.57812 5.57812 0.375 12 0.375C18.4219 0.375 23.625 5.57812 23.625 12Z","fill":"#4BD965"}));
}

FacebookInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = FacebookInline;

FacebookInline.default = FacebookInline;
